"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildStory = void 0;

var _react = _interopRequireDefault(require("react"));

var _bricks = require("./bricks.js");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var buildStory = function buildStory(_ref) {
  var story = _ref.story;
  return _react.default.createElement("div", {
    id: "bricks-story"
  }, story.map(function (section, index) {
    var Section = _bricks.BRICKS.sections[section.type];

    if (Section) {
      var _section$elements;

      return _react.default.createElement(Section, _extends({
        key: "section--".concat(index),
        id: "section--".concat(index)
      }, section.data), (_section$elements = section.elements) === null || _section$elements === void 0 ? void 0 : _section$elements.map(function (el, indexEl) {
        var Element = _bricks.BRICKS.elements[el.type];

        if (Element) {
          return _react.default.createElement(Element, _extends({
            key: "section--".concat(index, "__element--").concat(indexEl),
            id: "section--".concat(index, "__element--").concat(indexEl)
          }, el.data));
        } else {
          console.error("No element ".concat(indexEl, " of type ").concat(el.type));
          return null;
        }
      }));
    } else {
      console.error("No section ".concat(index, " of type ").concat(section.type));
      return null;
    }
  }));
};

exports.buildStory = buildStory;